import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./motion";

export function ImageBand({ src, alt, tag, testid, height = "h-[300px] sm:h-[440px]" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <section ref={ref} className="container-x py-4 sm:py-6" data-testid={testid}>
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-slate-200/90 shadow-xl shadow-ink/10">
          <motion.img
            src={src}
            alt={alt}
            style={{ y }}
            loading="lazy"
            className={`${height} w-full scale-[1.15] object-cover`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-transparent" />
          {tag && (
            <span className="absolute bottom-5 left-5 rounded-full bg-white/90 px-4 py-2 font-mono text-xs font-bold uppercase tracking-[0.2em] text-ink backdrop-blur">
              {tag}
            </span>
          )}
        </div>
      </Reveal>
    </section>
  );
}

export function CrestIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <path d="M24 3l16 5v14c0 10.5-6.8 18.9-16 23C14.8 40.9 8 32.5 8 22V8l16-5z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M16 20c2.7-1.8 5.3-1.8 8 0 2.7-1.8 5.3-1.8 8 0v9c-2.7-1.8-5.3-1.8-8 0-2.7-1.8-5.3-1.8-8 0v-9z" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M24 20v9" stroke="currentColor" strokeWidth="2.2" />
      <path d="M24 8l1.8 3.6 4 .6-2.9 2.8.7 4-3.6-1.9-3.6 1.9.7-4-2.9-2.8 4-.6L24 8z" fill="currentColor" />
    </svg>
  );
}

export function DotGrid({ className = "", light = false }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute ${className}`}
      style={{
        backgroundImage: `radial-gradient(circle, ${light ? "rgba(250,250,249,0.16)" : "rgba(15,23,42,0.10)"} 1.2px, transparent 1.2px)`,
        backgroundSize: "24px 24px",
      }}
    />
  );
}
